import { Box } from "@mui/material"
import styled from "styled-components"

export const DateFieldStyle = styled(Box)`
  .field-label {
    color: var(--slate-blue-color);
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 6px;
  }

  .MuiFormControl-root {
    .MuiInputBase-root {
      .MuiInputBase-input {
        height: 44px;
        padding: 10px 14px;
        font-size: 16px;
        font-weight: 400;
        &::placeholder {
          color: var(--cool-gray-color);
        }
      }
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid var(--light-blue-gray-color);
        border-radius: 16px;
      }
    }
  }
`
